import { DependencyList, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getTransfers } from 'src/actions';
import { Transfer } from 'src/models';
import { CustomHookBaseOptions } from 'src/models/common.model';

import { useAccountSelector } from './useAccountSelector';

const EMPTY_TRANSFERS: Transfer[] = [];

interface UseTransfersReturnType {
  transferList: Transfer[];
  isTransferListLoading: boolean;
  hasTransferListError?: boolean;
  transferListError?: string;
  isTransferListFetched: boolean;
}

interface UseTransfersOptions extends CustomHookBaseOptions {
  dependency?: DependencyList;
}

export const useTransfers = ({ skip, dependency }: UseTransfersOptions): UseTransfersReturnType => {
  const dispatch = useDispatch();
  const transferList: Transfer[] | undefined = useSelector((state: any) => state.cashiering.transfers?.data);
  const isTransferListLoading = useSelector((state: any) => Boolean(state.cashiering.transfers?.isLoading));
  const hasTransferListFailed: boolean = useSelector((state: any) => state.cashiering.transfers?.__failed);
  const transferListError: string = useSelector((state: any) => state.cashiering.transfers?.__message);
  const isFetched: boolean = useSelector((state: any) => Boolean(state.cashiering.transfers?.__isFetched));
  const { account } = useAccountSelector();

  useEffect(() => {
    if (!transferList && !isTransferListLoading && !skip && !hasTransferListFailed && Boolean(account?.accountId)) {
      dispatch(getTransfers(account?.accountId as number));
    }
  }, dependency);

  return {
    transferList: Array.isArray(transferList) ? transferList : EMPTY_TRANSFERS,
    isTransferListLoading,
    hasTransferListError: hasTransferListFailed,
    transferListError,
    isTransferListFetched: isFetched,
  };
};
